module.exports = __webpack_public_path__ + "media/images/icon__point--lost@2x-2f3693bbbe63d4770e5d8bca0cc47012.png";